import { Mail, Phone, MapPin } from "lucide-react";

export default function Contact() {
  return (
    <div className="py-16 px-10 bg-gray-50">

      {/* TITLE */}
      <h2 className="text-3xl font-bold text-center mb-10 text-gray-800">
        Contact Us
      </h2>

      {/* GRID */}
      <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">

        {/* EMAIL */}
        <div className="bg-white shadow-md rounded-lg p-6 text-center hover:shadow-lg transition">

          <div className="flex justify-center mb-4">
            <div className="bg-orange-100 p-3 rounded-full">
              <Mail className="text-orange-500" size={28} />
            </div>
          </div>

          <h3 className="font-semibold text-gray-800">Email</h3>
          <p className="text-gray-500 mt-2">
            support@jopodelivery.com
          </p>

        </div>

        {/* PHONE */}
        <div className="bg-white shadow-md rounded-lg p-6 text-center hover:shadow-lg transition">

          <div className="flex justify-center mb-4">
            <div className="bg-orange-100 p-3 rounded-full">
              <Phone className="text-orange-500" size={28} />
            </div>
          </div>

          <h3 className="font-semibold text-gray-800">Phone</h3>
          <p className="text-gray-500 mt-2">
            +255 689 966 875
          </p>

        </div>

        {/* LOCATION */}
        <div className="bg-white shadow-md rounded-lg p-6 text-center hover:shadow-lg transition">

          <div className="flex justify-center mb-4">
            <div className="bg-orange-100 p-3 rounded-full">
              <MapPin className="text-orange-500" size={28} />
            </div>
          </div>

          <h3 className="font-semibold text-gray-800">Location</h3>
          <p className="text-gray-500 mt-2">
            Kijitonyama, Dar Es Salaam, Tanzania
          </p>

        </div>

      </div>
    </div>
  );
}